'use client';
import { useEffect } from 'react';

function parseMarkdown(md) {
  let html = md
    // headings
    .replace(/^#### (.+)$/gm, (_, t) => `<h4 id="${slug(t)}">${t}</h4>`)
    .replace(/^### (.+)$/gm,  (_, t) => `<h3 id="${slug(t)}">${t}</h3>`)
    .replace(/^## (.+)$/gm,   (_, t) => `<h2 id="${slug(t)}">${t}</h2>`)
    .replace(/^# (.+)$/gm,    (_, t) => `<h1 id="${slug(t)}">${t}</h1>`)
    // blockquote
    .replace(/^> (.+)$/gm, (_, t) => `<blockquote><p>${t}</p></blockquote>`)
    // hr
    .replace(/^---$/gm, '<hr />')
    // bold + italic combo first
    .replace(/\*\*\*(.+?)\*\*\*/g, '<strong><em>$1</em></strong>')
    // bold
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    // italic
    .replace(/\*(.+?)\*/g, '<em>$1</em>')
    // inline code
    .replace(/`([^`]+)`/g, '<code>$1</code>')
    // links
    .replace(/\[(.+?)\]\((.+?)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');

  // ordered lists
  html = html.replace(/((?:^\d+\. .+\n?)+)/gm, (match) => {
    const items = match.trim().split('\n').map(l => `<li>${l.replace(/^\d+\. /, '')}</li>`).join('');
    return `<ol>${items}</ol>`;
  });

  // unordered lists (- or *)
  html = html.replace(/((?:^[-*] .+\n?)+)/gm, (match) => {
    const items = match.trim().split('\n').map(l => `<li>${l.replace(/^[-*] /, '')}</li>`).join('');
    return `<ul>${items}</ul>`;
  });

  // paragraphs — wrap remaining lines
  html = html.split('\n').map(line => {
    const t = line.trim();
    if (!t) return '';
    if (/^<(h[1-6]|ul|ol|li|blockquote|hr|pre|table|thead|tbody|tr|th|td)/.test(t)) return t;
    return `<p>${t}</p>`;
  }).join('');

  return html;
}

function slug(t) { return t.toLowerCase().replace(/[^a-z0-9]+/g, '-'); }

export default function BlogContent({ content }) {
  useEffect(() => {
    document.querySelectorAll('a[href^="#"]').forEach(a => {
      a.addEventListener('click', e => {
        e.preventDefault();
        const el = document.getElementById(a.getAttribute('href').slice(1));
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }, []);

  return (
    <article
      className="prose prose-dropcap max-w-none"
      dangerouslySetInnerHTML={{ __html: parseMarkdown(content) }}
    />
  );
}
